// Razorpay Checkout loader + unified pay flow (live or clearly-labeled TEST mode)
export const loadRazorpayScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

export const openRazorpayCheckout = (order, { onSuccess, onDismiss }) => {
  const options = {
    key: order.key_id,
    amount: order.amount,
    currency: order.currency,
    name: order.name,
    description: order.description,
    order_id: order.order_id,
    prefill: order.prefill,
    theme: { color: "#E8722A" },
    handler: (res) => onSuccess(res),
    modal: { ondismiss: () => onDismiss && onDismiss() },
  };
  const rz = new window.Razorpay(options);
  rz.open();
};
